import React, { useEffect } from 'react';
import { Row } from 'antd';

import { getOdsSummaryContent } from 'common/utils/send-communication';

import {
  ExcludedStations,
  NoStationsInCommon,
  OdsSummaryButton,
  SelectedCustomers,
  SelectedStations,
  TargetClientTypeProps,
} from './utils';

const TargetClientType = ({
  formik,
  isAllStationsChecked,
  hasNoStationsInCommon,
  shouldDisplaySelectedStationsCol,
  shouldDisplayExcludedStationsCol,
  hasOdsSummaryButton,
  isBulkCommunication,
  stations,
  stationsConcerned,
  excludedStations,
  handleCustomersSelectedChange,
  handleChangeCheckStations,
  handleChangeCheckAllStations,
  handleChangeCheckExcludeStations,
  setOdsSummaryContent,
}: TargetClientTypeProps) => {
  useEffect(() => {
    if (hasOdsSummaryButton) {
      setOdsSummaryContent(
        getOdsSummaryContent(stationsConcerned, formik.values.impactedStations, formik.values.excludedStations)
      );
    } else {
      setOdsSummaryContent([]);
    }
  }, [
    formik.values.excludedStations,
    formik.values.impactedStations,
    hasOdsSummaryButton,
    stationsConcerned,
    setOdsSummaryContent,
  ]);

  const odsSummaryContent = getOdsSummaryContent(
    stationsConcerned,
    formik.values.impactedStations,
    formik.values.excludedStations
  );

  return (
    <Row gutter={16}>
      <SelectedCustomers
        hasNoStationsInCommon={hasNoStationsInCommon}
        onSelectCustomersType={handleCustomersSelectedChange}
        selectedCustomersType={formik.values?.customersSelection}
        showTitle={!!isBulkCommunication}
      />

      {shouldDisplaySelectedStationsCol && (
        <SelectedStations
          formik={formik}
          stations={stations}
          impactedStations={formik.values.impactedStations}
          handleChangeCheckStations={handleChangeCheckStations}
          isAllStationsChecked={isAllStationsChecked}
          handleChangeCheckAllStations={handleChangeCheckAllStations}
        />
      )}

      {shouldDisplayExcludedStationsCol && (
        <ExcludedStations
          stations={excludedStations}
          excludedStations={formik.values.excludedStations}
          handleChangeCheckExcludeStations={handleChangeCheckExcludeStations}
        />
      )}

      {hasNoStationsInCommon && <NoStationsInCommon />}

      {hasOdsSummaryButton && <OdsSummaryButton content={odsSummaryContent} />}
    </Row>
  );
};

export default TargetClientType;
